import React from "react";
import { Card } from "antd";
import { motion } from "framer-motion";

// Icons (lucide-react)
import {
  Music,
  Tv,
  BookOpen,
  Dumbbell,
  Gamepad2,
} from "lucide-react";

export default function Hall11Facilities() {
  const facilities = [
    {
      title: "Music Room",
      desc:
        "Equipped with guitar, flute, keyboard, cajón, tabla, drums, mics, and speakers. A peaceful space for residents to practice and enjoy music.",
      icon: <Music size={28} />,
    },
    {
      title: "Indoor Sports Room",
      desc:
        "Includes TT tables, carrom boards, chess sets, and other indoor games for recreation and friendly competition.",
      icon: <Gamepad2 size={28} />,
    },
    {
      title: "TV Room",
      desc:
        "A large, comfortable lounge with a big-screen TV where residents gather to watch movies, sports, and live events.",
      icon: <Tv size={28} />,
    },
    {
      title: "Reading Room",
      desc:
        "A quiet and well-lit study space open throughout the day, ideal for studying, reading, or group discussions.",
      icon: <BookOpen size={28} />,
    },
    {
      title: "Gym",
      desc:
        "A basic fitness space equipped with bench press setup, dumbbells, ropes, and essential strength-training equipment.",
      icon: <Dumbbell size={28} />,
    },
  ];

  return (
    <div style={{ padding: "0 20px", minHeight: "80vh" }}>
      <h2
        style={{
          fontSize: "1.8rem",
          marginBottom: "20px",
          fontWeight: 600,
        }}
      >
        Facilities – Hall of Residence 11, IIT Kanpur
      </h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          alignItems:'center', justifyContent:'center',
          maxWidth: "800px",
          margin:'auto'
        }}
      >
        {facilities.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            // style={{ flex: "1 1 260px" }}
            style={{ display:'flex', alignItems:'center', justifyContent:'center' }}
          >
            <Card
            hoverable
              style={{
                borderRadius: "12px",
                height: "100%",
                width: '350px',
              }}
            >
              <div
                style={{
                //   display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "10px",
                }}
              >
                {item.icon}
                <h3 style={{ margin: 0, fontWeight: 600 }}>{item.title}</h3>
              </div>
              <p style={{ margin: 0, lineHeight: 1.5 }}>{item.desc}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
